import { Upload } from 'lucide-react';

interface FileDropZoneProps {
  file: File | null;
  onChange: (file: File | null) => void;
  accept?: string;
}

export function FileDropZone({ file, onChange, accept = 'image/*,video/*' }: FileDropZoneProps) {
  return (
    <label
      className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer transition-colors ${file ? 'border-primary bg-primary/5' : 'border-muted-foreground/30 hover:border-primary hover:bg-muted/50'}`}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => { e.preventDefault(); const f = e.dataTransfer.files?.[0]; if (f) onChange(f); }}
    >
      <Upload className="h-6 w-6 mb-1 text-muted-foreground" />
      <span className="text-sm text-muted-foreground">
        {file ? file.name : 'Drag & drop or click to select'}
      </span>
      <input type="file" className="hidden" accept={accept} onChange={(e) => onChange(e.target.files?.[0] || null)} />
    </label>
  );
}
